import Vue from 'vue'
import VueRouter from 'vue-router'
import isTest from './util/urltest'
import i18n from './lang/index'


// 以下皆为懒加载模式

// 我的
const iDSMyInfo = () => import('./views/iDSMyInfo')

// 关于
const iDSAbout = () => import('./views/iDSAbout')

// 密码登录
const iDSPwdLogin = () => import('./views/iDSPwdLogin')

// 验证码登陆
const iDSRegLogin = () => import('./views/iDSRegLogin')

// 重置密码
const iDSResetPwd = () => import('./views/iDSResetPwd')

// 修改密码
const iDSUpdatePwd = () => import('./views/iDSUpdatePwd')

// 设置密码
const iDSSetPwd = () => import('./views/iDSSetPwd')

// 404NotFound
const iDS404NotFound = () => import('./views/iDS404NotFound')

// 网络请求失败
const iDSNetworkError = () => import('./views/iDSNetworkError')

// Root
const iDSRoot = () => import('./views/iDSRoot')

// 服务协议
const eDSLicence = () => import('./views/eDSLicence')

// 服务协议
const eDSPrivacy = () => import('./views/eDSPrivacy')

// 消息盒子
const eDSSessionList = () => import('./views/messageBox/eDSSessionList')

// 消息列表
const eDSMessageList = () => import('./views/messageBox/eDSMessageList')

// 文档
const eDSDocument = () => import('./views/document/eDSDocument')

// 工作
const eDSWork = () => import('./views/work/eDSWork')
const eDSApproval = () => import('./views/work/eDSApproval')
const eDSFlowInfo = () => import('./views/work/eDSFlowInfo')
const eDSFlowInfo16 = () => import('./views/work/eDSFlowInfo16')
const eDSFlowFinish = () => import('./views/work/eDSFlowFinish')
const eDSTaskAgree = () => import('./views/work/eDSTaskAgree')
const eDSTaskRefuse = () => import('./views/work/eDSTaskRefuse')


var routes = [
  { name: 'licence', path: '/licence', component: eDSLicence },
  { name: 'privacy', path: '/privacy', component: eDSPrivacy },
  { name: 'sessionlist', path: '/sessionlist', component: eDSSessionList },
  { name: 'messagelist', path: '/messagelist', component: eDSMessageList },
  { name: 'document', path: '/document', component: eDSDocument },
  { name: 'work', path: '/work', component: eDSWork },
  { name: 'approval', path: '/approval', component: eDSApproval },
  { name: 'flowinfo', path: '/flowinfo', component: eDSFlowInfo },
  { name: 'flowinfo16', path: '/flowinfo16', component: eDSFlowInfo16 },
  { name: 'flowfinish', path: '/flowfinish', component: eDSFlowFinish },
  { name: 'taskagree', path: '/taskagree', component: eDSTaskAgree },
  { name: 'taskrefuse', path: '/taskrefuse', component: eDSTaskRefuse },
  { name: 'myinfo', path: '/myinfo', component: iDSMyInfo },
  { name: 'about', path: '/about', component: iDSAbout },
  { name: 'pwdlogin', path: '/pwdlogin', component: iDSPwdLogin },
  { name: 'reglogin', path: '/reglogin', component: iDSRegLogin },
  { name: 'resetpwd', path: '/resetpwd', component: iDSResetPwd },
  { name: 'updatepwd', path: '/updatepwd', component: iDSUpdatePwd },
  { name: 'setpwd', path: '/setpwd', component: iDSSetPwd },
  {
    name: 'networkerror',
    path: '/networkerror',
    component: iDSNetworkError
  },
  {
    name: 'root',
    path: '/',
    component: iDSRoot
  },
  {
    name: '*',
    path: '/*',
    component: iDS404NotFound
  }
]


// 显式创建 Vue Router 实例 (注：各页面中this.$router 是 Vue 实例对 router 的引用)
var router = new VueRouter({ routes }) // router 是一个变量名，可以随意命名，只要你将这个实例正确地挂载到 Vue 实例中即可（main.js）


// 路由全局守卫
router.beforeEach(async (to, from, next) => {
  // 浏览器标题栏的标题支持多语言翻译
  if (isTest) {
    document.title = i18n.t('密盾测试')
  } else {
    document.title = i18n.t('数络密盾')
  }
  next()
})

export default router 
